import { ResourceTag, UserTagType } from './testimonial';

export interface Tag {
  id: number;
  uuid: string;
  name: string;
  color: string;
  type?: UserTagType;
  updated_at?: string;
  created_at?: string;
  selected_at?: number;
}

export interface TaggableResource {
  uuid: string;
  tags?: ResourceTag[];
}

export enum TaggableResourceType {
  Testimonial = 'testimonial',
  TestimonialResponse = 'testimonial_response',
  VideoRecording = 'video_recording',
  UserAsset = 'user_asset',
  UserWebAsset = 'user_web_asset',
}

export enum TaggableResourcePage {
  ResponsePage = 'response_page',
  MyLibraryAll = 'my_library_all',
  MyLibraryUploaded = 'my_library_uploaded',
  MyLibraryRecording = 'my_library_recording',
  MyLibraryResponses = 'my_library_responses',
  TestimonialAll = 'testimonial_library_all',
  TestimonialResponses = 'testimonial_library_responses',
  TestimonialUploads = 'testimonial_library_uploads',
  SocialAll = 'social_all',
  SocialTwittter = 'social_twitter',
  SocialYoutube = 'social_youtube',
  TestimonialProject = 'testimonial_project',
}
